import type { ShaderModule } from '@use-gpu/shader';

import { useShader } from '../../hooks/useShader';
import { useScissorContext } from '../../providers/scissor-provider';

import { getScissorCombine } from '@use-gpu/wgsl/scissor/scissor-combine.wgsl';

import { getPositionScissor, getUVScissor, getSTScissor } from '@use-gpu/wgsl/scissor/scissor-level.wgsl';

export type ScissorMode = 'position' | 'uv' | 'st';

export const SCISSOR_GETTERS = {
  position: getPositionScissor,
  uv: getUVScissor,
  st: getSTScissor,
};

export const useCombinedScissor = (
  getScissor: ShaderModule,
  mode?: ScissorMode,
) => {
  const getter = SCISSOR_GETTERS[mode ?? 'position'];
  const scissor = useShader(getter, [getScissor]);

  const parent = useScissorContext();
  return parent ? useShader(getScissorCombine, [parent, scissor]) : scissor;
};

export const useScissorShader = () => useScissorContext();
